module.exports = __webpack_public_path__ + "img/c5201809-4.54b81134.jpg";